const RECOMMENDATION_IDS = {
  USER_CERTIFICATIONS: 'User Certifications',
  UNCERTIFIED_ACTIVE_USERS: 'Uncertified Active Users',
} as const;

export const CERTIFICATION_THRESHOLDS = {
  LOW: 1,
  MEDIUM: {
    MIN: 2,
    MAX: 3,
  },
  HIGH: 4,
} as const;

export default RECOMMENDATION_IDS;
